import { loadChart } from '@/common/utilities/nojq/_load.chart.js';

export default {
    name: 'mvtChart',
    props: {
        data: {
            default: () => null,
        },
        height: {
            default: () => null,
        },
        width: {
            default: () => null,
        },
    },
    methods: {
        inital() {
            var ctx = this.$refs.canvas.getContext('2d');
            var that = this;
            if (this.chartData) {
                if (this.height) {
                    ctx.height = this.height;
                }
                if (this.width) {
                    ctx.width = this.width;
                }
                loadChart().then(function (Chart) {
                    that._chartOb = new window.Chart(ctx, that.chartData);
                });
            }
        },
        update(chartData) {
            if (this._chartOb) {
                this._chartOb.data = chartData.data;
                this._chartOb.options = chartData.options;
                this._chartOb.update();
            }
        },
    },
    computed: {
        chartData() {
            return this.data;
        },
    },
    watch: {
        chartData(newVal, oldVale) {
            this.update(newVal);
        },
    },
    mounted() {
        this.inital();
    },
};
